import { CardNotice } from '@euler/app/flows/ai-suite/components/ChatCard';
import { parseBiDashboardChangesWidgetPayload } from '@euler/model/bi/widgets';
import { memo } from 'react';
import { ChangeSetCard } from './ChangeSetCard';

/**
 * The `bi_dashboard_changes` fence: a change set the assistant proposed,
 * read from the server by id, so its phase is always the current one.
 */
export const BiDashboardChangesWidget = memo(({ data }: { data: unknown }) => {
  const payload = parseBiDashboardChangesWidgetPayload(data);
  if (!payload)
    return <CardNotice text="这条看板修改的引用无效，请重新提问。" />;
  return (
    <ChangeSetCard
      key={payload.changeSetId}
      changeSetId={payload.changeSetId}
    />
  );
});
